var indexOf = [].indexOf;

angular.module('app.controllers').controller('ExhibitorsViewCtrl', ['$scope', '$rootScope', 'APIExhibitors', 'UI', 'APIRead', 'APIChats', '$interval', 'ngMeta'].append(function(self, root, APIExhibitors, UI, APIRead, APIChats, $interval, ngMeta) {
  var getChatRooms, ref, ref1, ref2, ref3, roomsInterval;
  self.id = parseInt(self.get('id')) || null;
  if (((ref = root.user) != null ? ref.role : void 0) === 'exhibitor') {
    if (self.id !== ((ref1 = root.session) != null ? (ref2 = ref1.user) != null ? ref2.id : void 0 : void 0)) {
      return root.logout();
    }
  }
  APIExhibitors.get({
    id: self.id,
    _entry: 'exhibitor',
    lang: 'en',
    country: (ref3 = root.session) != null ? ref3.user.country : void 0
  }, function(data) {
    self.data = data;
    self.data.infos = self.data.infos.map(function(block) {
      var ref4, ref5, url;
      if (!block.pathfactory) {
        return block;
      }
      url = new URL(block.pathfactory);
      url.searchParams.set('lb_email', ((ref4 = root.session) != null ? (ref5 = ref4.user) != null ? ref5.email : void 0 : void 0) || 'unlock-the-future.industry@siemens.com');
      block.pathfactory = url.toString();
      return block;
    });
    if (self.data.usecase_order == null) {
      self.data.usecase_order = [];
    }
    self.infos = self.data.infos.filter(function(info) {
      return !info.is_suc;
    }) || [];
    self.solutions = self.data.infos.map(function(info) {
      info.exhibitor_id = self.data.exhibitor_id;
      return info;
    }).filter(function(info) {
      return info.is_suc;
    }) || [];
    self.customStat(self.id, 'page_view', `Page ${self.data.title} opened`);
    getChatRooms();
    APIRead.query({
      entry_type: 'usecase',
      campaign: (self.data.exhibitor_type === 'campaign' ? self.data.id : self.data.campaign_id),
      exclude: self.id,
      lang: 'en'
    }, function(data) {
      return self.usecases = data.map(function(item, index, array) {
        var ref4;
        if (ref4 = item.exhibitor_id, indexOf.call(self.data.usecase_order, ref4) >= 0) {
          item.sortIndex = self.data.usecase_order.indexOf(item.exhibitor_id);
        } else {
          item.sortIndex = array.length + 1;
        }
        return item;
      });
    }, function(response) {
      return UI.notify(false, response.data.error);
    });
    if (self.data.exhibitor_type === 'campaign') {
      return APIRead.query({
        entry_type: 'campaign',
        limit: 3,
        random: true,
        full: true,
        splice: true,
        exclude: self.id,
        lang: 'en'
      }, function(data) {
        return self.campaigns = data;
      }, function(response) {
        return UI.notify(false, response.data.error);
      });
    }
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  self.trackBlock = function(block) {
    if (!block.track_in) {
      return;
    }
    block.tracked = true;
    return self.customStat(self.id, block.track_in_key || "", block.track_in_description || "", true, block.id);
  };
  
  // Chats logic

  self.rooms = [];
  getChatRooms = function() {
    var accounts, ref4, rooms;
    return false;
    accounts = (ref4 = self.data.presenter_contact_persons) != null ? ref4.map(function(contact) {
      return contact.chataccount;
    }).filter(function(contact) {
      return contact;
    }) : void 0;
    if (!accounts.length) {
      return;
    }
    rooms = [];
    return APIChats.query({
      _entry: 'meetings',
      accounts: accounts.join(","),
      include_offline: true
    }, function(data) {
      return data.forEach(function(item) {
        var ref5;
        return (ref5 = self.data.presenter_contact_persons.find(function(contact) {
          return contact.chataccount === item.account.id;
        })) != null ? ref5.room = item : void 0;
      });
    });
  };
  
  //self.joinChat(self.rooms[0], self.data.title, false) if self.rooms.length
  roomsInterval = $interval(getChatRooms, 10000);
  self.openChat = function(room) {
    return self.joinChat(room, self.data.title, false);
  };
  return self.$on('$destroy', function() {
    if (angular.isDefined(roomsInterval)) {
      $interval.cancel(roomsInterval);
      return roomsInterval = void 0;
    }
  });
}));
